/* REUSEABLE_SETTINGS */
export const GET_REUSEABLE_LIST = "GET_REUSEABLE_LIST"
export const GET_REUSEABLE_LIST_SUCCESS = "GET_REUSEABLE_LIST_SUCCESS"
export const GET_REUSEABLE_LIST_FAIL = "GET_REUSEABLE_LIST_FAIL"

export const GET_REUSEABLE_DETAILS = "GET_REUSEABLE_DETAILS"
export const GET_REUSEABLE_DETAILS_SUCCESS = "GET_REUSEABLE_DETAILS_SUCCESS"
export const GET_REUSEABLE_DETAILS_FAIL = "GET_REUSEABLE_DETAILS_FAIL"

export const ADD_NEW_REUSEABLE = "ADD_NEW_REUSEABLE"
export const ADD_REUSEABLE_SETTING_SUCCESS = "ADD_REUSEABLE_SETTING_SUCCESS"
export const ADD_REUSEABLE_SETTING_FAIL = "ADD_REUSEABLE_SETTING_FAIL"

export const UPDATE_REUSEABLE = "UPDATE_REUSEABLE"
export const UPDATE_REUSEABLE_SUCCESS = "UPDATE_REUSEABLE_SUCCESS"
export const UPDATE_REUSEABLE_FAIL = "UPDATE_REUSEABLE_FAIL"

export const DELETE_REUSEABLE = "DELETE_REUSEABLE"
export const DELETE_REUSEABLE_SUCCESS = "DELETE_REUSEABLE_SUCCESS"
export const DELETE_REUSEABLE_FAIL = "DELETE_REUSEABLE_FAIL"

export const EXPORT_REUSEABLE_EXCEL = "EXPORT_REUSEABLE_EXCEL"
export const EXPORT_REUSEABLE_EXCEL_SUCCESS = "EXPORT_REUSEABLE_EXCEL_SUCCESS"
export const EXPORT_REUSEABLE_EXCEL_FAIL = "EXPORT_REUSEABLE_EXCEL_FAIL"

export const RESET_REUSEABLE_SETTING_STATE = 'RESET_REUSEABLE_SETTING_STATE';
export const RESET_REUSEABLE_SETTING_ACTION_STATE = 'RESET_REUSEABLE_SETTING_ACTION_STATE';
